var map = {
	"./market-extensions/global/data.json": 97663,
	"./market-extensions/tha/data.json": 31051,
	"@com.amway.commerce/abomonetization-myshop-masterdata-v1-prod/data.json": 64473,
	"@com.amway.commerce/cart-cartconfig-v1-draft/data.json": 60272,
	"@com.amway.commerce/cart-cartconfig-v1-prod/data.json": 57719,
	"@com.amway.commerce/checkout-config-v1-prod/data.json": 31580,
	"@com.amway.commerce/identity-identity-config-v1-prod/data.json": 3426,
	"@com.amway.commerce/identity-username-config-v1-prod/data.json": 70527,
	"@com.amway.commerce/masterdata-country-v1-draft/data.json": 5418,
	"@com.amway.commerce/profile-contactmasterdata-v1-prod/data.json": 97592,
	"@com.amway.commerce/profile-myaccountaddress-v1-prod/data.json": 78394,
	"@com.amway.commerce/profile-myaccountprofile-v1-prod/data.json": 93227,
	"@com.amway.commerce/profile-registration-flow-config-v1-prod/data.json": 54826,
	"@com.amway.commerce/profile-registrationvalidations-v1-prod/data.json": 19037,
	"@com.amway.commerce/webshop-configs-v1-prod/data.json": 80808,
	"@com.amway.commerce/webshop-currency-v1-prod/data.json": 85960,
	"@commerce-order-webcomponents/sdk/dist/es/external/@com.amway.commerce/order-orderconfig-v1-prod/data.json": 71988,
	"ajv/lib/refs/data.json": 894,
	"babel-loader/node_modules/ajv/dist/refs/data.json": 1400,
	"babel-loader/node_modules/ajv/lib/refs/data.json": 3570,
	"core-js-compat/data.json": 16578,
	"market-extensions/global/data.json": 97663,
	"market-extensions/tha/data.json": 31051,
	"node_modules/@com.amway.commerce/abomonetization-myshop-masterdata-v1-prod/data.json": 64473,
	"node_modules/@com.amway.commerce/cart-cartconfig-v1-draft/data.json": 60272,
	"node_modules/@com.amway.commerce/cart-cartconfig-v1-prod/data.json": 57719,
	"node_modules/@com.amway.commerce/checkout-config-v1-prod/data.json": 31580,
	"node_modules/@com.amway.commerce/identity-identity-config-v1-prod/data.json": 3426,
	"node_modules/@com.amway.commerce/identity-username-config-v1-prod/data.json": 70527,
	"node_modules/@com.amway.commerce/masterdata-country-v1-draft/data.json": 5418,
	"node_modules/@com.amway.commerce/profile-contactmasterdata-v1-prod/data.json": 97592,
	"node_modules/@com.amway.commerce/profile-myaccountaddress-v1-prod/data.json": 78394,
	"node_modules/@com.amway.commerce/profile-myaccountprofile-v1-prod/data.json": 93227,
	"node_modules/@com.amway.commerce/profile-registration-flow-config-v1-prod/data.json": 54826,
	"node_modules/@com.amway.commerce/profile-registrationvalidations-v1-prod/data.json": 19037,
	"node_modules/@com.amway.commerce/webshop-configs-v1-prod/data.json": 80808,
	"node_modules/@com.amway.commerce/webshop-currency-v1-prod/data.json": 85960,
	"node_modules/@commerce-myshop-webcomponents/ui/node_modules/@com.amway.commerce/abomonetization-myshop-masterdata-v1-prod/data.json": 53099,
	"node_modules/@commerce-order-webcomponents/sdk/dist/es/external/@com.amway.commerce/order-orderconfig-v1-prod/data.json": 71988,
	"node_modules/ajv/lib/refs/data.json": 894,
	"node_modules/babel-loader/node_modules/ajv/dist/refs/data.json": 1400,
	"node_modules/babel-loader/node_modules/ajv/lib/refs/data.json": 3570,
	"node_modules/core-js-compat/data.json": 16578,
	"node_modules/webpack-dev-middleware/node_modules/ajv/dist/refs/data.json": 76773,
	"node_modules/webpack-dev-middleware/node_modules/ajv/lib/refs/data.json": 21755,
	"webpack-dev-middleware/node_modules/ajv/dist/refs/data.json": 76773,
	"webpack-dev-middleware/node_modules/ajv/lib/refs/data.json": 21755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82472;